import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ErrorStrings } from 'src/app/constants/form.constants';
import { User, UserAddress, UserAddressType } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user/user.service';
import { Alert } from 'src/app/interfaces/alert';
import { RedirectionParams, RedirectionService } from 'src/app/services/redirection/redirection.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-update-address',
  templateUrl: './update-address.component.html',
  styleUrls: ['./update-address.component.scss']
})

export class UpdateAddressComponent implements OnInit {
  loading = false;
  alert: Alert = null;
  address: UserAddress;
  errorStrings = ErrorStrings;
  addressId: number;
  user: User;
  redirectParams?: RedirectionParams;

  userAddressType = UserAddressType;
  isBrowser: boolean;

  constructor(
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private redirectionService: RedirectionService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.user = this.route.snapshot.data.user as User;
    this.addressId = Number(this.route.snapshot.paramMap.get('id'));
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  onSave() {
    this.closeAlert();
    this.loading = true;
    this.userService.saveAddress(this.address)
      .subscribe({
        next:() => {
          this.trackEvent(`${ this.address.addressType === UserAddressType.Main ? '' : '2nd'}addresschange::updated`);
          if (this.redirectParams) {
            this.router.navigate(this.redirectParams.l, { queryParams: this.redirectParams.q, fragment: this.redirectParams.f });
          } else {
            this.router.navigate(['/account']);
          }
        },
        error: errorMessage => {
          this.alert = {
            type: 'danger',
            message: errorMessage
          };
        }
      })
      .add(() => {
        this.loading = false;
      });
  }

  closeAlert() {
    this.alert = null;
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  ngOnInit(): void {
    this.address = this.user.addresses.find(address => address.id === this.addressId);

    // Setting redirection to be used when address is saved or when pressing back
    this.redirectParams = this.redirectionService.getParams(this.route.snapshot.queryParams.r);
  }
}
